<template>
  <NTooltip v-if="!isSSR" class="c-tooltip" placement="bottom" :showArrow="false">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </NTooltip>
</template>

<script setup lang="ts">
import { NTooltip, type TooltipProps } from 'naive-ui'

interface Props extends /* @vue-ignore */ TooltipProps {}

defineProps<Props>()
defineSlots()
const isSSR = typeof window === 'undefined'
</script>
